<script>
export default {
  name: "IndexComponent",
  props: {
    index: {
      type: Number,
      required: true
    }
  }
}
</script>

<template>
  <div class="td num">{{ index }}</div>
</template>

<style scoped>

</style>
